/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsBaseForSaasDataServices extends models.ServiceAccountNativeDetailsForSaas {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsBaseForSaasDataServices");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsBaseForSaasDataServices.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsBaseForSaasDataServices>): ServiceAccountNativeDetailsBaseForSaasDataServices {
        let obj = Object.assign(new ServiceAccountNativeDetailsBaseForSaasDataServices(), model);
        ServiceAccountNativeDetailsBaseForSaasDataServices.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsBaseForSaasDataServices>): ServiceAccountNativeDetailsBaseForSaasDataServices {
        if (!model) return null;
        return ServiceAccountNativeDetailsBaseForSaasDataServices.newInstance(<ServiceAccountNativeDetailsBaseForSaasDataServices> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsBaseForSaasDataServices) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsBaseForSaasDataServices.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsBaseForSaasDataServices): boolean {
        if (models.ServiceAccountNativeDetailsForSaas.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsBaseForSaasDataServices.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
